/* eslint-disable camelcase */
import { MOBILE_DASHBOARD_PRODUCT_NAMES } from 'src/apps/dashboard/constants/MobileDashboard.constants';
import {
	Core_Label_IssuesOrFilter,
	Uniqueness_IssuesOrFilter
} from 'src/common/types/graphql.generated';

export const buildMobileProductOrFilter = <
	T extends Uniqueness_IssuesOrFilter | Core_Label_IssuesOrFilter
>(): T[] =>
	MOBILE_DASHBOARD_PRODUCT_NAMES.map(
		(productName) =>
			({
				product_name_eq: { value: [productName] }
			}) as T
	);
